var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4738 30.5137L50.6016 38.7053L37.6056 39.3637L40.9972 51.9595L30.097 44.8331L25.4561 57.0221L20.8158 44.8331L9.91559 51.9595L13.3066 39.3637L0.310547 38.7053L10.4383 30.5137L0.310547 22.3221L13.3066 21.6636L9.91559 9.06715L20.8158 16.1936L25.4561 4.00452L30.097 16.1936L40.9972 9.06715L37.6056 21.6636L50.6016 22.3221",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4558 15.6183L28.0638 22.4675L34.1882 18.4629L32.2829 25.5413L39.5854 25.9112L33.8941 30.5141L39.5854 35.117L32.2829 35.4869L34.1882 42.5645L28.0638 38.5607L25.4558 45.4092L22.8486 38.5607L16.7234 42.5645L18.6287 35.4869L11.3262 35.117L17.0175 30.5141L11.3262 25.9112L18.6287 25.5413L16.7234 18.4629L22.8486 22.4675L25.4558 15.6183Z",
    fill: "white",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5131 44.1725C51.5131 44.1725 52.6908 37.7624 52.0117 33.0649C50.6718 23.8005 44.8209 21.6888 44.8209 21.6888C44.8209 21.6888 46.1721 26.9615 39.8255 36.179C34.4228 44.0255 37.7087 52.707 42.8097 55.1942H53.9067C53.9067 55.1942 59.456 52.445 59.6684 44.6425C59.6684 44.6425 60.2456 40.6153 55.5313 34.0766C55.5313 34.0766 56.7656 43.0173 51.5124 44.1725H51.5131Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8116 55.195C37.7107 52.7078 34.4248 44.0264 39.8274 36.1799C46.174 26.9623 44.8228 21.6897 44.8228 21.6897C44.8228 21.6897 50.6738 23.8013 52.0136 33.0657C52.6927 37.7625 51.5151 44.1733 51.5151 44.1733C51.5151 44.1733 56.5232 43.393 55.5396 34.0725",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9072 55.2096C59.0082 52.7224 62.2941 44.0267 56.8915 36.1803C56.3922 35.4546 55.9404 34.7538 55.5318 34.0779",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7718 1.0155H9.34184L4.06483 17.3518L8.39867 16.629L2.34668 36.6213L16.5449 11.096L10.3055 11.7911L13.7718 1.0155Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7718 1.0155H9.34184L4.06483 17.3518L8.39867 16.629L2.34668 36.6213L16.5449 11.096L10.3055 11.7911L13.7718 1.0155Z",
    fill: "white",
    stroke: "#005FC8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "static/media/flame.01923c14.svg";
export { ForwardRef as ReactComponent };